import TableGeneric from './TableGeneric';

export default TableGeneric;
